module.exports = __webpack_public_path__ + "static/klt@large-d6905ce1b1ddbadcbedcfebcdd3eba2a.jpg";